import { useEffect } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { useNavigate } from "react-router-dom";
import { VoiceContext } from "./VoiceContext";

export default function VoiceProvider({ children }) {

    const navigate = useNavigate();

    const { transcript, listening, resetTranscript } = useSpeechRecognition();
    // useEffect(() => {
    //     start(); // 🎤 AUTO START on app load
    // }, []);
    const start = () => {
        resetTranscript();
        SpeechRecognition.startListening({
            continuous: true,
            language: "en-IN"
        });
    };

    const stop = () => {
        SpeechRecognition.stopListening();
    };

    const commandMap = [
        // MAIN LINKS
        { keywords: ["home", "dashboard"], path: "/home" },

        // CUSTOMER
        { keywords: ["customer management", "customer mgmt"], path: "/customer-mgmt" },
        { keywords: ["customer account"], path: "/customer-account" },

        // TRIP
        { keywords: ["add trip"], path: "/add-trip" },
        { keywords: ["view trip"], path: "/view-trip" },

        // DEALER
        { keywords: ["dealer management"], path: "/dealer-mgmt" },
        { keywords: ["dealer account"], path: "/dealer-account" },

        // PURCHASE
        { keywords: [" purchase mgmt"], path: "/add-purchase" },
        { keywords: ["view purchase"], path: "/view-purchase" },

        // DAILY
        { keywords: ["other income"], path: "/other-income" },
        { keywords: ["other expense"], path: "/other-expense" },

        // PAYROLL
        { keywords: ["staff management"], path: "/staff-mgmt" },
        { keywords: ["attendance"], path: "/attendance" },
        { keywords: ["advance payment"], path: "/advance-payment" },
        { keywords: ["monthly payment"], path: "/monthly-payment" },

        // VEHICLE
        { keywords: ["vehicle management"], path: "/vehicle-mgmt" },
        { keywords: ["matoshri vehicles"], path: "/matoshri-vehicles" },
        { keywords: ["fuel entry"], path: "/fuel-entry" },

        // REPORTS
        { keywords: ["sale purchase report"], path: "/sale-purchase-report" },
        { keywords: ["daily income expense"], path: "/daily-income-expense" },
        { keywords: ["customer report"], path: "/customerwise-report" },
        { keywords: ["product report"], path: "/productwise-report" },
        { keywords: ["vehicle report"], path: "/vehiclewise-report" },
        { keywords: ["collection report"], path: "/collection-report" },
        { keywords: ["whatsapp report"], path: "/whatsapp-report" },
        { keywords: ["salary report"], path: "/salary-report" }
    ];

    const parseCommand = (text) => {
        const t = text.toLowerCase();

        // 🔥 AUTO NAVIGATION FROM MAP
        for (let cmd of commandMap) {
            for (let key of cmd.keywords) {
                if (t.includes(key)) {
                    return { type: "NAVIGATE", path: cmd.path };
                }
            }
        }

        // 🔹 ACTIONS
        if (t.includes("save")) return { type: "CLICK", target: "save-btn" };
        if (t.includes("add")) return { type: "CLICK", target: "add-btn" };
        if (t.includes("delete")) return { type: "CLICK", target: "delete-btn" };
        if (t.includes("edit")) return { type: "CLICK", target: "edit-btn" };

        return null;
    };

    // 🎯 EXECUTE COMMAND
    const executeCommand = (cmd) => {
        if (!cmd) return;

        // NAVIGATION
        if (cmd.type === "NAVIGATE") {
            navigate(cmd.path);
        }

        if (cmd.type === "CLICK") {
            const elements = document.querySelectorAll(`[data-voice="${cmd.target}"]`);

            for (let el of elements) {
                if (el.offsetParent !== null) { // visible element
                    el.click();
                    break;
                }
            }
        }
    };

   useEffect(() => {
    if (!transcript) return;

    const cmd = parseCommand(transcript);

    if (cmd) {
        executeCommand(cmd);

        // 🔥 HARD RESET
        SpeechRecognition.stopListening();
        resetTranscript();

        setTimeout(() => {
            SpeechRecognition.startListening({
                continuous: true,
                language: "en-IN"
            });
        }, 300);
    }

}, [transcript]);

    return (
        <VoiceContext.Provider value={{ start, stop, listening, transcript }}>
            {children}
        </VoiceContext.Provider>
    );
}